import { useDateTimeField } from '@atlassian/jira-issue-field-date-time';
import { DATETIME_CF_TYPE } from '@atlassian/jira-platform-field-config';
import { useGenericClipboardHandler } from '../../../clipboard-handler/utils';
import type {
	ClipboardItem,
	ListIssueFieldTransformed,
	PasteHandler,
	PasteMetadata,
} from '../../../types';
import { createClipboardHelperComponent } from '../../utils';
import { dateTimeSupportedTypes } from '../supported-field-types';

const getPastedValue = (clipboardItem: ClipboardItem, metadata: PasteMetadata | null) => {
	if (!clipboardItem || !clipboardItem.plainText || !metadata?.fieldValue || !metadata?.fieldType) {
		return null;
	}

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	if (!(dateTimeSupportedTypes as string[]).includes(metadata.fieldType)) {
		return null;
	}

	return clipboardItem.plainText;
};

const useDateTimeClipboardHandler: PasteHandler = (
	issue: { key: string },
	field: ListIssueFieldTransformed,
) => {
	const [, { saveValue }] = useDateTimeField({
		issueKey: issue.key,
		fieldKey: field?.fieldId,
	});

	return useGenericClipboardHandler(field, getPastedValue, saveValue);
};

const DateTimeClipboardHelper = createClipboardHelperComponent(useDateTimeClipboardHandler);

export const dateTimeClipboardHandler = {
	[DATETIME_CF_TYPE]: DateTimeClipboardHelper,
};
